import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasCategoryContext, withCategory } from "@insite/client-framework/Components/CategoryContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    return {
        breadcrumbLinks: state.components.breadcrumbs.links,
        linksState: state.links,
        nodeId: getCurrentPage(state).nodeId,
        homePageUrl: getHomePageUrl(state),
        enableStructuredData:
            state.context?.settings?.settingsCollection?.websiteSettings?.enableOrganizationStructuredData,
        website: state.context?.website,
        location,
    };
};

type Props = WidgetProps & HasCategoryContext & ReturnType<typeof mapStateToProps>;

// interface Props extends WidgetProps, HasCategoryContext {}

export interface CategoryDetailBannerStyles {
    container?: InjectableCss;
}

export const bannerStyles: CategoryDetailBannerStyles = {
    container: {
        css: css`
            .category_container {
                margin: 0px 0 0 15px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                margin: 35px 0 0 0;
                            `,
                        ],
                        "max",
                    )}
            }
            .category_container .img_cat_container {
                float: left;
                width: 30%;
            }
            .category_container .img_cat_container.img_containerbanner {
                float: none;
                width: 100%;
            }
            .category_container .desc_cat_container.desc_maincategory {
                width: 100%;
                margin-left: 0;
            }
            .category_container .desc_cat_container {
                display: inline-block;
                width: 66%;
                margin-left: 20px;
            }
            .category_container .desc_cat_container a.btn {
                background-size: 100% 200%;
                background-color: ${getColor("primary")};
                transition: all 200ms ease-in-out;
                span {
                    font-size: 15px;
                    font-weight: bold;
                    color: rgb(255, 255, 255);
                    padding: 0.5em 1.2em;
                }
                &:hover {
                    background-color: hsl(354.6, 73.7%, 33.4%);
                }
            }
            .category_container .desc_cat_container .contactBtn ${TypographyStyle} {
                color: ${getColor("secondary.contrast")};
                padding: 0.5em 1.2em;
            }

            .prod_desc_div .prod_logo {
                margin-bottom: 1.25rem;
            }

            .prod_logo {
                margin-bottom: 1.25rem;
            }

            .prod_desc_div .prod_logo img {
                max-width: 140px;
                margin-right: 20px;
                margin-bottom: 20px;
                vertical-align: middle;
            }

            .prod_logo img {
                max-width: 140px;
                margin-right: 20px;
                margin-bottom: 20px;
                vertical-align: middle;
            }

            .prod_logo span {
                display: inline;
            }

            .prod_content_wrapper {
                padding: 15px 30px;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-flex-direction: row;
                -ms-flex-direction: row;
                flex-direction: row;
                -webkit-flex-wrap: wrap;
                -ms-flex-wrap: wrap;
                flex-wrap: wrap;
                -webkit-justify-content: flex-start;
                -ms-flex-pack: start;
                justify-content: flex-start;
                -webkit-align-content: stretch;
                -ms-flex-line-pack: stretch;
                align-content: stretch;
                -webkit-align-items: center;
                -ms-flex-align: center;
                align-items: center;
            }

            .prod_content_wrapper .prod_img {
                width: 25%;
                padding-right: 30px;
                -webkit-order: 0;
                -ms-flex-order: 0;
                order: 0;
                -webkit-flex: 0 1 auto;
                -ms-flex: 0 1 auto;
                flex: 0 1 auto;
                -webkit-align-self: auto;
                -ms-flex-item-align: auto;
                align-self: auto;
            }

            .prod_content_wrapper .prod_desc_div {
                width: 75%;
                padding-right: 30px;
                -webkit-order: 0;
                -ms-flex-order: 0;
                order: 0;
                -webkit-flex: 0 1 auto;
                -ms-flex: 0 1 auto;
                flex: 0 1 auto;
                -webkit-align-self: auto;
                -ms-flex-item-align: auto;
                align-self: auto;
            }

            h3 {
                font-size: 24px !important;
                margin: 5px 0;
                line-height: 24px;
                font-weight: 600;
                text-transform: capitalize !important;
            }

            @media only screen and (max-width: 767px) {
                .prod_desc_div .prod_logo img {
                    max-width: 125px !important;
                }

                .prod_content_wrapper {
                    padding: 15px;
                }

                .prod_content_wrapper .prod_img,
                .prod_content_wrapper .prod_desc_div {
                    width: 100%;
                    padding-right: 0;
                    padding-bottom: 30px;
                }

                .category_container .desc_cat_container {
                    margin-left: 0px;
                }
            }

            @media only screen and (max-width: 767px) {
                .category_container .img_cat_container,
                .category_container .desc_cat_container {
                    float: none;
                    width: 100%;
                }

                .category_container .desc_cat_container .contactBtn {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                }
            }
        `,
    },
};

const styles = bannerStyles;

const CategoryDetailBanner = ({ category, breadcrumbLinks }: Props) => {
    // if (!category || !category.htmlContent) {
    //     return null;
    // }
    const isH1Present = category?.htmlContent?.includes("h1");
    const productListName = breadcrumbLinks && breadcrumbLinks[breadcrumbLinks.length - 1].children;

    return (
        <StyledWrapper {...styles.container} data-test-selector="categoryDetailBanner_htmlContent">
            {category && category?.htmlContent
                ? parse(category.htmlContent, parserOptions)
                : !isH1Present && <VisuallyHidden as="h1">{translate(`${productListName}`)}</VisuallyHidden>}
        </StyledWrapper>
    );
};

const CategoryDetailBanners = connect(mapStateToProps)(CategoryDetailBanner);

const widgetModule: WidgetModule = {
    component: withCategory(CategoryDetailBanners),
    definition: {
        group: "Category Details",
        icon: "image-landscape",
        allowedContexts: ["CategoryDetailsPage", "ProductListPage"],
    },
};

export default widgetModule;
